var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-aside", attrs: { id: "page-aside" } }, [
    _c("div", {
      staticClass: "page-aside-content px-lg-30 py-50",
      attrs: { id: "page-aside-content" },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "page-aside-close icon",
        attrs: { id: "page-aside-close" },
      },
      [
        _c("img", {
          attrs: { src: require("@/assets/sprite/svg/close.svg?raw"), alt: "" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }